import { DESC } from 'NewAngular/constants/core.constants';
import { FolderableAppType } from 'FoldersApp/enums/folderable-app-type.enum';
export const DELETE_TALKING_POINT_ERROR_MESSAGE = 'An error occurred while deleting the talking point. Please try again or contact support.';
export const DUPLICATE_TALKING_POINT_ERROR_MESSAGE = 'An error occurred while duplicating the talking point. Please try again or contact support.';
export const DUPLICATE_TALKING_POINT_DOES_NOT_EXIST_ERROR_MESSAGE = 'The talking point you are duplicating does not exist in our database. Please try a different talking point.';
export const SAVE_TALKING_POINT_ERROR_MESSAGE = 'An error occurred while saving the talking point. Please try again or contact support.';
export const TALKING_POINT_FORBIDDEN_ERROR_MESSAGE = 'You do not have access to this talking point.';
export const TALKING_POINTS_LIST_DEFAULT_SORT_DIRECTIONS = { user_modify_date: DESC };
export const TALKING_POINTS_FOLDERABLE_APP_CONFIG = {
    appName: 'TalkingPointsApp',
    folderableAppType: FolderableAppType.LIST_PAGE,
    itemNamePlural: 'Talking Points',
};
